export const API_URL = "https://admin-api.muavietlot.com";
